import { render, staticRenderFns } from "./SecondMenu.vue?vue&type=template&id=1fab1a4f"
import script from "./SecondMenu.vue?vue&type=script&lang=js"
export * from "./SecondMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports